/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Audiences_DescriptionInputs */

const en_directory_taxonomy_audiences_description = /** @type {(inputs: Directory_Taxonomy_Audiences_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use audience-based paths when a role or working context matters more than a product category.`)
};

const zh_directory_taxonomy_audiences_description = /** @type {(inputs: Directory_Taxonomy_Audiences_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当角色或工作环境比产品分类更重要时，可通过适用人群快速进入相关路径。`)
};

/**
* | output |
* | --- |
* | "Use audience-based paths when a role or working context matters more than a product category." |
*
* @param {Directory_Taxonomy_Audiences_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_audiences_description = /** @type {((inputs?: Directory_Taxonomy_Audiences_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Audiences_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_audiences_description(inputs)
	return zh_directory_taxonomy_audiences_description(inputs)
});
export { directory_taxonomy_audiences_description as "directory.taxonomy.audiences.description" }